import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { environmentCommon } from '../../../../environments/environment-common';
import { BRAND } from '../../../data/brand/brand.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { PRODUCT_LINES, COMPANIES } from '../../../data/product/product.data';

@Component({
  selector: 'app-sr-engineers-page',
  templateUrl: './sr-engineers-page.component.html',
  styleUrls: ['./sr-engineers-page.component.scss']
})
export class SrEngineersPageComponent {
  BRAND = BRAND;
  URLS = URLS;
  PRODUCT_LINES = PRODUCT_LINES;
  COMPANIES = COMPANIES;

  environment = environment;
  environmentCommon = environmentCommon;

  exploreTitle = [
    { text: $localize`:@@homePage.exploreTitle.1:SR Engineers`, level: 1 },
    // { text: $localize`:@@homePage.exploreTitle.2:known for ittttt` }
  ];
}
